import React from 'react';
import PropTypes from 'prop-types';

import { Typography as MUITypography } from '@mui/material';

export const Typography = props => <MUITypography {...props} />;

Typography.propTypes = {
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object,
  color: PropTypes.oneOf([
    'error',
    'inherit',
    'primary',
    'secondary',
    'textPrimary',
    'textSecondary'
  ]),
  component: PropTypes.elementType,
  gutterBottom: PropTypes.bool,
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  variant: PropTypes.oneOf([
    'body1',
    'body2',
    'button',
    'caption',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'inherit',
    'overline',
    'srOnly',
    'subtitle1',
    'subtitle2'
  ])
};

export default Typography;
